import { Observable } from 'rxjs';
import { AccountObjectApiFacade } from '../account-object/account-object.api-facade';
import { JobData } from './job-data.model';

export abstract class JobDataApiFacade<T extends JobData> extends AccountObjectApiFacade<T> {

    abstract get(accountId: string, jobId: string, id: string, ...args): Observable<T>;

    abstract getAll(accountId: string, ...args): Observable<Array<T>> ;

    abstract getByJob(accountId: string, jobId: string, ...args): Observable<Array<T>> ;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-data/job-data.api-facade.ts